var exports = {
  "A": "xe533113f--5fc331--outer",
  "v": "xe533113f--5fc331--inner",
};

module.exports = exports;
